export const configItemsSubscription = [
  { title: 'Лайки без ограничений', iconUrl: '/icons/bottom_bar_button_1.svg' },
  { title: 'Видите кто вас лайкнул', iconUrl: '/icons/paywall-like.svg' },
  { title: '5 супер-лайков в неделю', iconUrl: '/icons/paywall-superlike.svg' },
  { title: '5 возвратов в неделю', iconUrl: '/icons/paywall-reload.svg' },
  { title: 'Видите кто идёт на мероприятие', iconUrl: '/icons/at-icons_calendar.svg' },
  { title: 'Нет рекламы + подарок', iconUrl: '/icons/paywall-gift.svg' },
];